import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import styled from 'styled-components';

import type { IWeekDay } from '@/types/calendar';

import { formatStartEndTimeWithTimezone, getBlockSettings } from '@/helpers';
import { useTimezone } from '@/hooks';

interface IShiftTooltipProps {
  children: React.ReactElement;
  canShow: boolean;
  shiftData: {
    id: string;
    clientName: string;
    scheduleName: string;
  };
  startBlockId: number;
  endBlockId: number;
  scheduleIndex: number;
  day: IWeekDay;
}

const ShiftTooltip = ({
  children,
  canShow,
  shiftData,
  startBlockId,
  endBlockId,
  scheduleIndex,
  day,
}: IShiftTooltipProps): React.ReactElement => {
  const { clientName, scheduleName, id } = shiftData;
  const { timezoneName } = useTimezone();

  const blockSettings = getBlockSettings(startBlockId, endBlockId, timezoneName, day);

  return (
    <OverlayTrigger
      trigger={['hover', 'focus']}
      placement="top"
      show={canShow ? false : undefined}
      overlay={
        <TooltipContainer id={`tooltip-${id}`}>
          <p className="schedule-name">
            {scheduleIndex}. {scheduleName}
          </p>
          <p className="client-name">{clientName}</p>
          <p className="time">{formatStartEndTimeWithTimezone(blockSettings)}</p>
        </TooltipContainer>
      }
    >
      {children}
    </OverlayTrigger>
  );
};

export { ShiftTooltip };

const TooltipContainer = styled(Tooltip)`
  .tooltip-inner {
    width: 126px;

    p {
      margin: 0 0 5px 0;
      font-size: 10px;
    }

    .schedule-name {
      font-weight: 800;
    }

    .client-name {
      font-weight: 600;
    }

    .time {
      font-weight: 600;
    }
  }
`;
